<template>
	<div class="col-sm-6">
		<h2>{{headline}}</h2>
		<ul class="nav nav-tabs">
			<li v-for="(item, index) in contents">
				<a class="nav-link" :class="getClassObject(index)" :data-item-index="index" v-on:click.prevent="changeContent" href="#">{{item.language}}</a>
			</li>
		</ul>
		<div class="form-group">
			<erco-text-area v-if="ismultiline" :text="contents[currentContentIndex].text"></erco-text-area>
			<erco-text-input v-else :text="contents[currentContentIndex].text"></erco-text-input>
		</div>

	</div>
</template>
<script>
	import ErcoTextArea from '@/components/atoms/ErcoTextArea';
	import ErcoTextInput from '@/components/molecules/ErcoTextInput';

	export default {
		name: 'ErcoTextEditorOrganism',
		data() {
			return {
				currentContentIndex: 0,
			};
		},
		props: {
			contents: {
				type: Object,
				required: true,
				default() {
					return [{ language: 'DE', text: 'Das ist ein Text' }];
				},
			},
			headline: {
				type: String,
				required: true,
				default: 'headline',
			},
			ismultiline: {
				type: Boolean,
				default: true,
			},
		},
		methods: {
			changeContent() {
				const element = event.currentTarget;
				this.currentContentIndex = parseInt(element.getAttribute('data-item-index'), 10);
			},
			getClassObject(index) {
				return {
					active: index === this.currentContentIndex,
				};
			},
		},
		components: {
			ErcoTextArea,
			ErcoTextInput,
		},
	};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// ErcoTextEditor.vue?2d416c15